


































import store from '../store';
import { openLinkInBrowser } from '@/mla-shared';

export default {
  data () {
    return {
      title: 'Home'
    }
  },
  methods: {
    async openPasture (e: Event) {
      e.preventDefault();
      openLinkInBrowser('https://elearning.mla.com.au/courses/pasture-utilisation/');
    },
    async openElearning (e: Event) {
      e.preventDefault();
      openLinkInBrowser('https://elearning.mla.com.au/');
    },
  },
  store
}
